export default "<app-reports-header></app-reports-header>\r\n"